import { Rating } from "components/Cards"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { FiX } from "react-icons/fi"

export default ({ handleSetComment, cancel }) => {
  const [rate, setRate] = useState(0)
  const [message, setMessage] = useState("")
  const { t } = useTranslation();

  const handleRate = (index, allowClick) => {
    if (allowClick && index === rate) {
      setRate((prev) => prev - 1)
    }
    if (allowClick && index !== rate) {
      setRate(() => index)
    }
  }
  const handleClose = () => {
    cancel()
    setRate(0)
    setMessage("")
  }
  return (
    <section className="relative w-full p-8 py-10 bg-white">
      <button className="absolute top-8 right-8" onClick={handleClose}>
        <FiX size={24} />
      </button>
      <div className="flex flex-col items-start justify-center w-full gap-3">
        <Rating allowClick commonRate={rate} handleRate={handleRate} />
        <div className={`${rate ? "text-white" : "text-red-500"} py-1`}>
          *{t('comment-alert')}
        </div>
        {/* <div className="w-3/5">
          <label className="sr-only" htmlFor="message">
            Исми ва фамилияси
          </label>
          <input
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            className="w-full border-2 rounded-md p-3 text-base font-normal focus:outline-[color:var(--custom-primary)]"
            placeholder="Исми ва фамилияси"
            disabled={!rate && true}
          />
        </div> */}
        <div className="w-3/5">
          <label className="sr-only" htmlFor="message">
            {t('comment')}
          </label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className="w-full border-2 rounded-md p-3 text-base font-normal focus:outline-[color:var(--custom-primary)]"
            placeholder={`${t('comment')}...`}
            rows="8"
            maxLength="350"
            disabled={!rate && true}
          />
          <span>{message.length}/350</span>
        </div>
        <div className="mt-4">
          <button
            disabled={(!rate || !message) && true}
            className="px-6 py-3 text-white bg-[color:var(--custom-primary)] flex justify-center items-center text-lg rounded-md disabled:opacity-50"
            onClick={() => handleSetComment(rate, message)}
          >
            {t('leave-comment')}
          </button>
        </div>
      </div>
    </section>
  )
}
